// extracted by mini-css-extract-plugin
export var label = "_ks-2";
export var slideContainer = "_ks-0";
export var slider = "_ks-1";